import React from 'react';
import { FaStar, FaEye, FaHeart, FaMapMarkerAlt, FaUsers, FaCalendar } from 'react-icons/fa';
  const PackageAnalytics = () => {
  const totalViews = 0;
  const totalReviews = 0;
  const avgRating = '0.0';
  const totalBookings = 0;
  const categories = [];
  const topLocations = [];
  const maxLocationBookings = 1;
  const ratingDistribution = [
    { stars: 5, count: 0 },
    { stars: 4, count: 0 },
    { stars: 3, count: 0 },
    { stars: 2, count: 0 },
    { stars: 1, count: 0 }
  ];
  const maxRatingCount = 1;
  const performanceMetrics = [
    { label: 'Conversion Rate', value: '0%', trend: 'No data', color: '#28A745' },
    { label: 'Avg Booking Value', value: 'PKR 0', trend: 'No data', color: '#4A9E8E' },
    { label: 'Customer Satisfaction', value: '0/5', trend: 'No data', color: '#FFB800' },
    { label: 'Repeat Customers', value: '0%', trend: 'No data', color: '#2C5F7C' }
  ];

  return (
    <div className="adm-pkg-analytics-container">
      <div className="adm-pkg-analytics-metrics">
        <div className="adm-pkg-metric-card">
          <div className="adm-pkg-stat-icon" style={{ backgroundColor: '#E8F4F8' }}>
            <FaEye style={{ color: '#2C5F7C', fontSize: '24px' }} />
          </div>
          <div>
            <h3>0</h3>
            <p>Total Views</p>
          </div>
        </div>

        <div className="adm-pkg-metric-card">
          <div className="adm-pkg-stat-icon" style={{ backgroundColor: '#FFF8E1' }}>
            <FaStar style={{ color: '#FFB800', fontSize: '24px' }} />
          </div>
          <div>
            <h3>{avgRating}</h3>
            <p>Average Rating</p>
          </div>
        </div>

        <div className="adm-pkg-metric-card">
          <div className="adm-pkg-stat-icon" style={{ backgroundColor: '#E6F7F9' }}>
            <FaHeart style={{ color: '#17A2B8', fontSize: '24px' }} />
          </div>
          <div>
            <h3>{totalReviews}</h3>
            <p>Total Reviews</p>
          </div>
        </div>

        <div className="adm-pkg-metric-card">
          <div className="adm-pkg-stat-icon" style={{ backgroundColor: '#E8F8EA' }}>
            <FaCalendar style={{ color: '#28A745', fontSize: '24px' }} />
          </div>
          <div>
            <h3>{totalBookings}</h3>
            <p>Total Bookings</p>
          </div>
        </div>
      </div>
      <div className="adm-pkg-performance-card">
        <div className="adm-pkg-card-header">
          <h3>Performance Metrics</h3>
        </div>
        <div className="adm-pkg-performance-grid">
          {performanceMetrics.map((metric, index) => (
            <div key={index} className="adm-pkg-performance-item">
              <div className="adm-pkg-performance-label">{metric.label}</div>
              <div className="adm-pkg-performance-value" style={{ color: metric.color }}>
                {metric.value}
              </div>
              <div className="adm-pkg-performance-trend">
                {metric.trend}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="adm-pkg-analytics-row">
        <div className="adm-pkg-analytics-card">
          <div className="adm-pkg-card-header">
            <h3>Package Categories</h3>
          </div>
          <div className="adm-pkg-card-body">
            <div className="adm-pkg-empty-state">No category data available</div>
          </div>
        </div>

        <div className="adm-pkg-analytics-card">
          <div className="adm-pkg-card-header">
            <h3>Rating Distribution</h3>
          </div>
          <div className="adm-pkg-card-body">
            <div className="adm-pkg-empty-state">No rating data available</div>
          </div>
        </div>
      </div>

      <div className="adm-pkg-analytics-card adm-pkg-full-width">
        <div className="adm-pkg-card-header">
          <h3>
            <FaMapMarkerAlt /> Top Destination Locations
          </h3>
        </div>
        <div className="adm-pkg-card-body">
          <div className="adm-pkg-locations-grid">
            <div className="adm-pkg-empty-state">No location data available</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PackageAnalytics;